<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <v-row>

      <v-col cols="12">
        <v-toolbar color="primary d-flex justify-center rounded-lg" dense>
          <v-toolbar-title color="primary">
            <span class="white--text"> Libreta de notas del estudiante </span>
          </v-toolbar-title>
        </v-toolbar>
      </v-col>

      <template v-if="datoLogin.licencia_perfil == 'familiar'">
        <v-row class="pa-5">
          <v-col cols="4">
            <v-autocomplete label="Estudiante" :items="listAlumno" item-value="id" item-text="nombre_apellido"
              @change="getLibretaNotasFamiliar($event)" return-object>
            </v-autocomplete>
          </v-col>
          <v-col class="py-3">
            <div class="nivel">
              <p>Nivel:</p>
              <span>{{ NivelAlumno }}</span>
            </div>
          </v-col>
          <v-col class="py-3">
            <div class="grado">
              <p>Grado:</p>
              <span>{{ GradoAlumno }}</span>
            </div>
          </v-col>
          <v-col class="py-3">
            <div class="seccion">
              <p>Sección:</p>
              <span> {{ SeccionAlumno }}</span>
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-if="datoLogin.licencia_perfil != 'familiar' && datoLogin.licencia_perfil != 'estudiante'">

        <v-col cols="12" md="2">
          <v-select :disabled="isDisabled" label="Año lectivo" v-model="filter.id_ano_lectivo"
            @change="EventAnoLectivo(filter.id_ano_lectivo)" :items="listAnoLectivo" item-value="id"
            item-text="nom_anolectivo">
          </v-select>
        </v-col>

        <v-col cols="12" md="2">
          <v-select label="Nivel" v-model="filter.id_nivel" @change="EventNivel(filter.id_nivel)" :items="listNivel"
            item-value="id" item-text="desc_nivel">
          </v-select>
        </v-col>

        <v-col cols="12" md="2">
          <v-select label="Grado" v-model="filter.id_grado" @change="EventGrado(filter.id_grado)" :items="listGrado"
            item-value="id" item-text="desc_grado">
          </v-select>
        </v-col>

        <v-col cols="12" md="2">
          <v-select label="Sección" v-model="filter.id_seccion" @change="EventSeccion()" :items="listSeccion"
            item-value="id" item-text="nombre_seccion">
          </v-select>
        </v-col>

        <v-col cols="12" md="2">
          <v-autocomplete label="Estudiante" v-model="filter.id_alumno" :items="listAlumno" item-value="id"
            item-text="nombre_apellido" @change="getLibretaNotas">
          </v-autocomplete>
        </v-col>

      </template>
      <!--  -->
      <v-col cols="auto" class="d-flex justify-end align-center">
        <TableButtonComp normalButton @click="GenerarLibreta()" :disabled="generandoPDF" :loading="generandoPDF"
          text-button="Generar libreta" iconBut="fa-regular fa-file-pdf" />
      </v-col>

      <v-col cols="12">

        <div style="overflow-x: auto; width: 100%">
          <v-data-table dense :headers="headerLibretaNotas" :items="dataAreasEval" class="transparent elevation-0 my-4"
            hide-default-header :items-per-page="15" mobile-breakpoint="0">
            <template #header="{}">
              <thead class="v-data-table-header">
                <tr>
                  <th v-for="(h, i) in headerLibretaNotas" :key="i" :class="h.class" :rowspan="h.periodo ? 1 : 2"
                    :colspan="h.periodo ? listPeriodo.length : 1">
                    {{ h.text }}
                  </th>
                </tr>
                <tr>
                  <th v-for="(h1, i1) in listPeriodo" :key="i1" class="text-center black--text" style="padding:0">
                    {{ h1.nombre_periodo }}
                  </th>
                  <th v-if="listPeriodo.length != 0" class="text-center black--text bg-compArea">
                    COMPETENCIA
                  </th>
                  <!-- <th v-if="listPeriodo.length != 0" class="text-center black--text bg-compArea">
                  ÁREA
                </th> -->
                </tr>
              </thead>
            </template>
            <template v-slot:item="{ item }">
              <tr class="styleBorder">
                <td style="
                      border-left: solid 1px #e0e0e0;
                      border-right: solid 1px #e0e0e0;
                    " :rowspan="item.evaluacion ? item.evaluacion.length + 1 : 1">
                  <strong> {{ item.desc_area.toUpperCase() }} </strong>
                </td>
              </tr>
              <tr class="styleBorder" v-for="(child, index) in item.evaluacion"
                :key="`${item.evaluacion[index].id_competencia}${item.id}`">
                <td :style="index == 0 ? 'border-top: solid 1px #e0e0e0' : ''">
                  <i>{{ child.competencia }} </i>
                </td>
                <td :style="index == 0 ? 'border-top: solid 1px #e0e0e0' : ''" class="ChildstyleBorder" v-for="(c, ci) in obtenerFilasCompetencias(
                  child.periodo,
                  item.id
                )" :key="ci">
                  <strong style="color: green" v-if="c == 4"> AD </strong>
                  <strong style="color: blue" v-else-if="c == 3"> A </strong>
                  <strong style="color: brown" v-else-if="c == 2"> B </strong>
                  <strong style="color: red" v-else-if="c == 1"> C </strong>
                  <strong v-else> {{ c }} </strong>
                  <!-- <span> {{ c }} </span> -->
                </td>
                <!-- <td v-if="index == 0" style="background: #fdeec1" :rowspan="item.evaluacion ? item.evaluacion.length : 1">
                <strong style="color: green" v-if="promCompetencia(item) == 4">
                  AD
                </strong>
                <strong style="color: blue" v-else-if="promCompetencia(item) == 3">
                  A
                </strong>
                <strong style="color: brown" v-else-if="promCompetencia(item) == 2">
                  B
                </strong>
                <strong style="color: red" v-else-if="promCompetencia(item) == 1">
                  C
                </strong>
                <strong v-else> {{ promCompetencia(item) }} </strong>
              </td> -->
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="verPdf" persistent scrollable max-width="100%">
      <v-card>
        <v-card-title class="modal_title py-5 mb-2">
          <v-row class="d-flex justify-space-between py-0">
            {{ archivo.filename }}
            <v-btn fab dark x-small class="btn_style3" @click="verPdf = false"><v-icon dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>
        <iframe :src="archivo.uri" type="application/pdf" width="100%" height="800px"></iframe>
      </v-card>
    </v-dialog>

    <!-- LOADER INICIAR VISTA  -->
    <v-dialog v-model="loadingSpiner.estado" :width="loadingSpiner.ancho">
      <v-card :color="loadingSpiner.colorDialog" dark>
        <v-card-text class="pt-2 text-center">
          {{ loadingSpiner.titulo }}
          <v-progress-linear indeterminate :color="loadingSpiner.color" class="mb-0">
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";

import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import NProgress from "nprogress";
import "nprogress/nprogress.css";


import TableButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";
let _ = require("lodash");

export default {
  name: "LibretaDeNotas",
  components: {
    TableButtonComp
  },
  data: () => ({

    isDisabled: false,

    paramComponente: { id_submodulo: 98, id_modulo: 8 },
    datoLogin: sessionStorage,
    verPdf: false,
    parametros: {
      archivo: null,
      titulo: "",
    },
    filter: {},
    listPeriodo: [],
    listAnoLectivo: [],
    listNivel: [],
    listGrado: [],
    listGradoTemp: [],
    listSeccion: [],
    listSecTemp: [],

    NivelAlumno: "",
    GradoAlumno: "",
    SeccionAlumno: "",


    dialog: false,
    listAlumno: [],
    archivo: {
      filename: "",
      uri: "",
    },
    base_url: `${API_URL}`,
    generandoPDF: false,

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      selectReq2: (value) =>
        (value || "").length > 0 || "Debe seleccionar un campo de la lista",

      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
    },

    headerLibretaNotas: [
      {
        text: "ÁREAS",
        align: "start",
        sortable: false,
        value: "id",
        class: "secondary black--text text-center",
      },
      {
        text: "COMPETENCIAS",
        value: "desc_area",
        class: "secondary black--text text-center",
      },
      {
        text: "NIVEL DE LOGRO POR PERIODO",
        value: "evaluacion",
        divider: true,
        periodo: [
          { text: "PERIODO 1" },
          { text: "PERIODO 2" },
          { text: "PERIODO 3" },
          { text: "PERIODO 4" },
        ],
        class: "secondary black--text text-center bg-nivelPeriodos",
      },
      {
        text: "NIVEL LOGRO FINAL",
        value: "promedio",
        divider: true,
        periodo: [{ text: "COMPETENCIA " }],
        class: "secondary black--text text-center bg-nivelLogroFinal",
      },
    ],
    dataAreasEval: [], //, { text: "ÁREA" }

    headerNotasConducta: [
      {
        text: "PERIODO",
        align: "start",
        sortable: false,
        value: "id",
        class: "secondary black--text",
      },
      {
        text: "INCIDENCIA",
        value: "desc_area",
        class: "secondary black--text",
      },
      {
        text: "OBSERVACIÓN",
        value: "evaluacion",
        class: "secondary black--text",
      },
      {
        text: "PUNTAJE",
        value: "puntaje",
        class: "secondary black--text",
      },
    ],
    dataConducta: [],
    headerAreaCompetencias: [
      {
        text: "AREAS",
        align: "start",
        sortable: false,
        value: "id",
        class: "secondary black--text text-center",
      },
      {
        text: "COMPETENCIAS",
        value: "desc_area",
        class: "secondary black--text text-center",
      },
      {
        text: "CONCLUSIÓN DESCRIPTIVA",
        value: "conclusion",
        class: "secondary black--text text-center bg-nivelPeriodos",
      },
    ],
    dataAreasCom: [],
  }),
  computed: {
    ...mapState(["loadingSpiner"]),
    ...mapGetters("login", ["componenteEvento"]),
    totals() {
      let totals = {};
      this.listPeriodo.forEach((periodo) => {
        totals[periodo.nombre_periodo] = 0;
      });
      this.dataAreasEval.forEach((area) => {
        if (area.evaluacion) {
          area.evaluacion.forEach((evaluacion) => {
            evaluacion.periodo.forEach((p) => {
              if (p.nota_alumno) {
                totals[p.nombre_periodo] += p.nota_alumno / 3;
              }
            });
          });
        }
      });
      return totals;
    },
  },
  mounted() {
    this.LoadMain();
  },
  created() {
    this.ActualizarParamentro();
  },
  methods: {
    ...mapActions("login", ["parametroComponente"]),

    ActualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    /** 
     __________________________
    | FUNCION CERRAR DIALOGO */
    closeModal() {
      this.verPdf = false;
    },
    /** 
     _________________________
    | FUNCION CARGA INICIAL */
    async LoadMain() {

      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();

      this.LimpiarFiltros();


      switch (this.datoLogin.licencia_perfil) {

        case 'administrador':
          this.GetAnoLectivo();
          // this.GetNivel();
          break;

        case 'docente':
          this.isDisabled = true
          this.cargarDatosPerfilDocente()
          break;

        case 'familiar':
          this.cargarDatosPerfilFamilia()
          break;

        case 'estudiante':
          this.cargarDatosPerfilEstudiante();
          break;

        case 'coordinador':
          this.cargarDatosPerfilCoordinador();
          break;

        case null:
          break;

        case "":
          break;

        default:
          // this.GetNivel();
          this.GetAnoLectivo();
          break;
      }

      setTimeout(async () => {
        NProgress.done();
      }, 500);

    },
    /** 
     ________________________________
    | FUNCION CARGAR DATOS FAMILIA */
    async cargarDatosPerfilFamilia() {

      try {
        let params = {
          id_colegio: this.datoLogin.id_colegio,
          id_persona: this.datoLogin.id_persona,
          id_anio_lectivo: this.datoLogin.id_ano_lectivo,
        };
        const response = await axios.post("/academico/padre/all/alu/", params);


        let dataAlumno = response.data.map(valor => {
          return { ...valor, id: valor.id_alumno, nombre_apellido: valor['persona.nombre_completo'] };
        });

        this.listAlumno = dataAlumno;

      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /** 
     ________________________________
    | FUNCION CARGAR DATOS DOCENTE */
    async cargarDatosPerfilDocente() {
      try {
        let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(
          `/academico/progDocente/getQuery${params}`
        );


        console.log('dada', response);



        const { CurrentAnoLectivo, NivelDoc, GradoDoc, SeccionDoc } = response.data.payload;

        this.listAnoLectivo = CurrentAnoLectivo
        this.filter.id_ano_lectivo = CurrentAnoLectivo[0].id

        let NivelDocFilter = NivelDoc.map(valor => {
          return { ...valor, id: valor.id_nivel };
        });

        let GradoDocFilter = GradoDoc.map(valor => {
          return { ...valor, id: valor.id_grado };
        });

        let SeccionDocFilter = SeccionDoc.map(valor => {
          return { ...valor, id: valor.id_seccion, nombre_seccion: valor.desc_seccion };
        });

        console.log('SeccionDocFilter', SeccionDocFilter);


        this.listNivel = NivelDocFilter;
        this.listGradoTemp = GradoDocFilter;
        this.listSecTemp = SeccionDocFilter;

      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /** 
     ___________________________________
    | FUNCION CARGAR DATOS ESTUDIANTE */
    async cargarDatosPerfilEstudiante() {
      try {
        let response = await axios.get(`evaluacion/reporte/listarDatosAlumno/${this.datoLogin.id_persona}`);

        const { DATOS_ALUMNOS_SECION_AREA_NIVEL } = response.data
        this.filter.id_alumno = DATOS_ALUMNOS_SECION_AREA_NIVEL.id_alumno;
        this.filter.id_seccion = DATOS_ALUMNOS_SECION_AREA_NIVEL.id_seccion;
        this.filter.id_grado = DATOS_ALUMNOS_SECION_AREA_NIVEL.id_adm_grado;
        this.filter.id_nivel = DATOS_ALUMNOS_SECION_AREA_NIVEL.id_adm_nivel;
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      } finally {
        this.getLibretaNotas();
      }
    },

    /** 
     _____________________________________
    | FUNCION CARGAR DATOS COORDINADOR */
    async cargarDatosPerfilCoordinador() {
      try {
        let params = {
          id_colegio: this.datoLogin.id_colegio,
          id_ano_lectivo: this.datoLogin.id_ano_lectivo,
          id_persona: this.datoLogin.id_persona
        }
        const response = await axios.post('/academico/coordinador/act/alu/niv/', params);

        let NivelDocFilter = response.data.map(valor => {
          return { id: valor.id_nivel, desc_nivel: valor.desc_nivel };
        });

        this.listNivel = NivelDocFilter;
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /** 
     ___________________________
    | FUNCION LISTAR PERIODOS */
    async GetPeriodo(id_nivel) {
      const id_colegio = this.datoLogin.id_colegio;
      const id_ano_lectivo = this.datoLogin.id_ano_lectivo;

      let params = { id_colegio, id_ano_lectivo };
      try {
        let response = await axios.post(`/sistema/integral/getPeriodo/`, {
          filter: params,
        });


        this.listPeriodo = response.data.filter(
          (objeto) => objeto.id_adm_nivel == id_nivel
        );

      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetAnoLectivo() {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
      };

      try {
        let response = await axios.post(`/sistema/integral/getAnoLectivo/`, {
          filter: params,
        });

        this.listAnoLectivo = response.data;

      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },




    /** 
     __________________________
    | FUNCION LISTAR NIVELES */
    async GetNivel(id_anio_lectivo) {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: id_anio_lectivo,
      };
      try {
        let response = await axios.post(`/sistema/integral/getNivelAdm/`, {
          filter: params,
        });

        this.listNivel = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     ________________________
    | FUNCION LISTAR GRADO */
    async GetGrado(id_colegio, id_nivel) {
      let params = { id_colegio, id_nivel };
      try {
        let response = await axios.post(`/sistema/integral/getGradoAdm/`, {
          filter: params,
        });
        this.listGrado = response.data;

      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     ____________________________
    | FUNCION LISTAR SECCIONES */
    async GetSeccion(id_colegio, id_grado) {
      let params = { id_colegio, id_grado };
      try {
        let response = await axios.post(`/sistema/integral/getSeccionAdm/`, {
          filter: params,
        });
        this.listSeccion = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     __________________________
    | FUNCION LISTAR ALUMNOS */
    async GetAlumnos() {
      let params = {
        id_ano_lectivo: this.filter.id_ano_lectivo,
        id_colegio: this.filter.id_colegio,
        id_seccion: this.filter.id_seccion,
      };
      let response = await axios.post(`/sistema/integral/getAlumnoSeccion/`, {
        filter: params,
      });

      this.listAlumno = response.data.result
    },
    /** 
     _______________________________
    | FUNCION SELECCIONAR PERIODO */
    EventPeriodo(items) {
      // this.listNivel = [];
      this.listGrado = [];
      this.listSeccion = [];
      this.listAlumno = [];
      // this.filter.id_nivel = "";
      this.filter.id_grado = "";
      this.filter.id_seccion = "";
      this.filter.id_alumno = "";
      // this.GetNivel(id_periodo);
      this.GetGrado(this.datoLogin.id_colegio, items.id_nivel);
    },

    EventAnoLectivo(id_ano_lectivo) {
      this.listNivel = [];
      this.filter.id_grado = "";
      this.filter.id_seccion = "";
      this.filter.id_alumno = "";
      this.listSeccion = [];
      this.listGrado = [];
      this.listAlumno = [];


      this.GetNivel(id_ano_lectivo)
    },



    /** 
     _____________________________
    | FUNCION SELECCIONAR NIVEL */
    EventNivel(id_nivel) {

      this.filter.id_grado = "";
      this.filter.id_seccion = "";
      this.filter.id_alumno = "";
      this.listSeccion = [];
      this.listGrado = [];
      this.listAlumno = [];

      switch (this.datoLogin.licencia_perfil) {
        case 'docente':
          this.listGrado = this.listGradoTemp.filter(
            (v) =>
              v.id_nivel == id_nivel
          );
          break;

        default:
          this.GetGrado(this.datoLogin.id_colegio, id_nivel)
          break;
      }
    },
    /** 
     _____________________________
    | FUNCION SELECCIONAR GRADO */
    EventGrado(id_grado) {
      this.filter.id_seccion = "";
      this.filter.id_alumno = "";
      this.listSeccion = [];
      this.listAlumno = [];

      switch (this.datoLogin.licencia_perfil) {
        case 'docente':
          this.listSeccion = this.listSecTemp.filter(
            (v) =>
              v.id_grado == id_grado
          );
          break;

        default:
          this.GetSeccion(this.filter.id_colegio, id_grado);
          break;
      }


    },
    /** 
     _______________________________
    | FUNCION SELECCIONAR SECCION */
    EventSeccion() {
      this.filter.id_alumno = "";
      this.listAlumno = [];
      this.GetAlumnos();
    },
    /** 
     _______________________________________________
    | FUNCION CARGAR LIBRETA PERFIL PADRE FAMILIA */
    async getLibretaNotasFamiliar(alumno) {
      this.filter.id_alumno = alumno.id
      this.filter.id_seccion = alumno.id_seccion
      this.filter.id_grado = alumno.id_adm_grado
      this.filter.id_nivel = alumno.id_adm_nivel

      this.NivelAlumno = alumno.desc_nivel;
      this.GradoAlumno = alumno.desc_grado;
      this.SeccionAlumno = alumno.nombre_seccion;
      this.getLibretaNotas();
    },
    /** 
     ____________________________________________________
    | FUNCION OBTENER SOLO LIBRETA DE NOTAS DEL ALUMNO */
    async getLibretaNotas() {

      this.$store.commit("mostrarLoading", {
        titulo: "Cargando libreta",
        color: "#fff",
        colorDialog: "#212121",
        ancho: 300,
      });

      this.GetPeriodo(this.filter.id_nivel);
      this.dataAreasCom = [];
      this.dataAreasEval = [];
      this.dataConducta = [];
      try {
        const response = await axios.post(
          `evaluacion/reporte/soloLibretaDeNotas/`,
          { filter: this.filter }
        );

        // me.dataAreasCom = response.data.DATA_AREA_COMPETENCIA;
        this.dataAreasEval = response.data.DATA_AREA_NOTA;

      } catch (error) {
        console.error(error);
      } finally {
        NProgress.done();
        this.$store.commit("ocultarLoading");
      }
    },
    /** 
     ___________________________________________________
    | FUNCION GENERAR LIBRETA DE NOTAS DEL ALUMNO PDF */
    async GenerarLibreta() {

      if (this.dataAreasEval.length == 0) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `No existe información`,
          tiempo: null,
        });
      }

      if (this.filter.id_alumno == "") {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe seleccionar un estudiante`,
          tiempo: null,
        });
      } else {
        this.generandoPDF = true;
        try {
          let response = await axios.post(
            `evaluacion/reporte/libretaDeNotas/`,
            { filter: this.filter, responseType: "blob" }
          );

          if (response.data.messageT == "S") {
            this.archivo = {
              uri: `${this.base_url}evaluacion/reporte/libretaDeNotas/${this.filter.id_colegio}/${response.data.filename}`,
              filename: response.data.filename,
            };
            this.verPdf = true;
          } else {
            this.setEnviarMens({
              tipo: response.data.messageT,
              mensaje: response.data.message,
              tiempo: null,
            });
          }
        } catch (error) {
          console.log(error);
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
        this.generandoPDF = false;
      }
    },
    /** 
     ___________________________
    | FUNCION LIMPIAR FILTROS */
    LimpiarFiltros() {
      this.filter = {
        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_alumno: "",
        id_periodo: "",
        id_nivel: "",
        id_grado: "",
        id_seccion: "",
        id_usuario: this.datoLogin.id,
      };
    },
    /** 
     ________________________________
    | FUNCION FILTRAR COMPETENCIAS */
    obtenerFilasCompetencias(rows, idx) {
      // let cont = 0;
      // let sumar = 0;
      // let ultimaNotaPeriodo = 0;
      // let nota;
      const result = {};
      _.forEach(rows, (key, index2) => {
        if (key.nota_alumno) {
          // cont++;
          // nota = key.nota_alumno;
          result["c" + index2] = key.nota_alumno.toFixed();
          // sumar += nota;
        } else {
          result["c" + index2] = "-";
        }
      });

      result["competencia" + idx] = result["c3"]
      // (sumar / cont).toFixed();
      return result;
    },
    /** 
     _____________________________________
    | FUNCION CALCULOS AVG COMPETENCIAS */
    promCompetencia(item) {
      let suma = 0;
      if (item.evaluacion) {
        item.evaluacion.forEach((evalItem) => {
          suma +=
            this.obtenerFilasCompetencias(evalItem.periodo, item.id)[
            "competencia" + item.id
            ] / item.evaluacion.length;
        });
      }
      return suma.toFixed();
    },
  },
};
</script>
<style scoped>
.nivel,
.grado,
.seccion {
  width: 100%;
  height: 50px;
  position: relative;
  border-bottom: 1px solid #1565c0;
}

.nivel span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.seccion span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.grado span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.nivel p {
  font-size: 13px;
}

.grado p {
  font-size: 13px;
}

.seccion p {
  font-size: 13px;
}

.v-data-table-header {
  background-color: #bdbdbd;
}

.border {
  border: 1px solid rgba(0, 0, 0, 0.42);
}

.bg-nivelLogroFinal {
  background: #858585 !important;
  /* style="padding-top: 5px; text-align: start !important; border-top: 1px #919191 solid; color:#1e1e1e;" */
  border-bottom: solid 1px #979696 !important;
}

.bg-nivelPeriodos {
  border-bottom: solid 1px #979696 !important;
}

.bg-compArea {
  background: #858585 !important;
}

.styleBorder td.ChildstyleBorder {
  /* border: thin solid rgba(0,0,0,.12) !important; */
  border-left: solid 1px #e0e0e0;
  border-right: solid 1px #e0e0e0;

  /* border-right: solid 1px #e0e0e0; */
}
</style>
